import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, combineLatest } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { AuthenticateAdminService } from '@services/dws';
import { AccountsService } from '@services/accounts.service';

@Injectable({
  providedIn: 'root'
})
export class OnlyAdminAuthorizedGuard implements CanActivate {
  constructor(
    private auth: AuthenticateAdminService, 
    private accounts: AccountsService,
    private router: Router
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const adminAuth$ = this.auth.authorization$.pipe(first());
    const accountsAuth$ = this.accounts.authorization$.pipe(first());
    const login$ = this.accounts.login$.pipe(first());
    
    return combineLatest([adminAuth$, accountsAuth$, login$])
      .pipe(map(([adminAuth, accountsAuth, login]) => {
        const isAdminViaAdminService = !!adminAuth;
        const isAdminViaAccountsService = !!(accountsAuth?.is_admin && accountsAuth?.is_winery);
        const isAccountSuperAdmin = this.accounts.hasActiveSuperAdminSession(login);
        
        if (isAdminViaAdminService || isAdminViaAccountsService || isAccountSuperAdmin) {
          return true;
        }
        if (login) {
          return this.router.parseUrl('/');
        }
        return this.router.createUrlTree(['/login'], { queryParams: { redirectTo: state.url } });
      }))
  }
}
